module.exports = __webpack_public_path__ + "img/政务2.0dc195a0.png";